import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getDashboardFinancieroEmitidas (params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mock.getFinancialDashboardEmitidas)
      }, 500)
    })
  } else {
    const req = {
      url: '/api/dashboard/getdashboardfinancieroemitidas',
      method: 'POST',
      data: params,
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      }
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getDashboardFinancieroEmitidas }
